/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Empty_State_TitleInputs */



/**
* | output |
* | --- |
* | "No issues found" |
*
* @param {Manual_Qc_Empty_State_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_empty_state_title = /** @type {((inputs?: Manual_Qc_Empty_State_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Empty_State_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun incident trouve")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurden keine Probleme gefunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun problema trovato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проблем не обнаружено")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron problemas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未发现问题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("問題は見つかりませんでした")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई समस्या नहीं पाई गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum problema encontrado")
	return /** @type {LocalizedString} */ ("No issues found")
});